<template>
  <div>
    <v-row no-gutters justify="start">
      <div class="side-content-small ml-6">
        <v-row no-gutters align="center" class="content-header">
          <v-btn class="n-white-btn n-small-btn px-2 mr-2" @click="backToMakersList()">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-col class="text-truncate">
            <div class="font-weight-bold text-truncate">
              {{ maker.name }}
            </div>
          </v-col>
        </v-row>
        <div class="left-admin-nav">
          <ul>
            <li
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ active: tab.isActive }"
              @click="goTo(tab.path)"
            >
              <v-icon class="float-right">keyboard_arrow_right</v-icon>
              <div>{{ tab.text }}</div>
            </li>
          </ul>
        </div>
      </div>
      <v-col align="center" class="pa-0 mx-6">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `SettingsMainLayout`,
  data: () => ({
    // rawItems: [
    //   { text: `Infos générales`, path: `/settings/makers/:makerId/infos` },
    //   // { text: `Sites`, path: `/settings/makers/:makerId/sites` },
    //   { text: `Utilisateurs`, path: `/settings/makers/:makerId/users` },
    //   // { text: `Équipements`, path: `/settings/makers/:makerId/equipments`, isPreviewFeature: true },
    //   // { text: `Contrats de maintenance`, path: `/settings/makers/:makerId/maintenance-contracts`, isPreviewFeature: true },
    // ],
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/settingsMakers`, {
      maker: `currentAdminMaker`,
    }),
    ...mapState(`ui/mainLayout`, [`isDemoApp`, `isLocalApp`]),
    ...mapState(`ui/settings`, [
      `aggregatorMakerTabs`,
    ]),
    isSlugMaker() {
      return this.maker?.slug !== ``;
    },
    tabs() {
      return _.chain(this.aggregatorMakerTabs)
        .filter(tab =>
          !(tab.hideOnSlugMaker === true && this.isSlugMaker)
        )
        .map(tab => {
          const path = tab.path.replace(/:makerId/g, this.maker.id);
          return {
            ...tab,
            path,
            isActive: this.$route.path === path,
          };
        })
        .value();
    },
    // items() {
    //   return _.chain(this.rawItems)
    //     .filter(item => _.isUndefined(item.isPreviewFeature) || this.isDemoApp || this.isLocalApp)
    //     .map(item => ({
    //       ...item,
    //       isActive: this.routePath === item.path,
    //     }))
    //     .value();
    // },
    routePath() {
      return this.$route.path.replace(/makers\/\d+/g, `makers/:makerId`);
    },
  },
  methods: {
    backToMakersList() {
      this.$store.commit(`ui/settingsMakers/SET_KEEPING_PREVIOUS_STATE`, true);
      this.$router.push(`/settings/makers`);
    },
    goTo(path) {
      if (path !== this.routePath) {
        const realPath = path.replace(/:makerId/, this.$route.params.makerId);
        this.$router.push(realPath);
      }
    },
  },
  beforeMount() {
  },
};
</script>

<style lang="scss">
</style>
